import {BaseClient} from '../utils/base-client';

class LookupTablesClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    const baseUrl = workspaceId ? `api/app/workspaces/${workspaceId}` : `api/app/projects/${projectId}`;
    return `${baseUrl}/data-definitions/lookup-tables`;
  }

  public buildRequestBody({dataGroupIds}) {
    // dataGroupIds are included in body of DELETE requests
    return dataGroupIds ? JSON.stringify({'data-group-ids': dataGroupIds}) : null;
  }

  public processResponse(response) {
    if (response.status === `error`) {
      throw response.error;
    }
    return response.results;
  }
}

export const lookupTablesClient = new LookupTablesClient();
